import React, { useEffect, useRef, useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import CustomForm from "../components/CustomForm";
import Table from "../components/Table";
import { usHttp2 } from "../custom-hooks/use-http";
import appvariables from "../appvariables";
import { useDispatch } from "react-redux";
import { notificationsliceactions } from "../store/notification";
import { loadingsliceactions } from "../store/loading-slice";
import Details from "../components/Details";

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, 
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const EditProductGroup = () => {
    const [mq, setMq] = useState(0);
    const mqref = useRef();

    const [mqerror, setMqerror] = useState('');

    const [pname, setPname] = useState('');
    const [packagee, setPackagee] = useState('');
    const [company, setCompany] = useState('');
    const psref = useRef();
    const [pserror, setPserror] = useState('');
    const [products, setProducts] = useState([]);

    const masterdispatcher = useDispatch();

    const navigate = useNavigate();

    const { productstrings } = useLoaderData();
    const { pgdetails } = useLoaderData();

    const [productstringset, setProductstringset] = useState(new Set());

    useEffect(() => {
        const kk = new Set(productstrings);
        setProductstringset(kk);
    }, [productstrings]);

    useEffect(() => {
        if(pgdetails)
        {
            setMq(parseInt(pgdetails['mq']));
            mqref.current.value = parseInt(pgdetails['mq']);
            let temp = [];
            for(let i=0; i < pgdetails['products'].length; i++)
            {
                let newdata = {
                    'name': pgdetails['products'][i].name,
                    'package': pgdetails['products'][i].package,
                    'company': pgdetails['products'][i].company,
                    'rowkey': uuidv4()
                }
                temp.push(newdata);
            }
            setProducts(temp);
        }
    },[pgdetails]);

    const mqinputchange = () => {
        setMq(Math.max(0, mqref.current.value))
    }


    const psinputchange = () => {
        var product_var = (psref.current.value).split('---');
        if(product_var.length === 3)
        {
            setPname(product_var[0]);
            setPackagee(product_var[1]);
            setCompany(product_var[2]);
            psinputblur();
        }
        else
        {
            setPname('');
            setPackagee('');
            setCompany('');
        }
    }

    const psinputblur = () => {
        if(psref.current.value.trim() === '')
        {
            setPserror('Select Product');
        }
        else if(!(productstringset.has(psref.current.value)))
        {
            setPserror('Select Product from options if the required product is not available add that in Add Product Page');
        }
        else{
            setPserror('');
        }
    }

    const addpstolocal = (e) => {
        e.preventDefault();
        let newdata = {
            'name': pname,
            'package': packagee,
            'company': company,
            'rowkey': uuidv4()
        }
        let temp = [...products];
        temp.push(newdata);
        setProducts(temp);
        setPname('');
        setPackagee('');
        setCompany('');
        psref.current.focus();
        psref.current.value = ''
        setPserror('');
    }

    const deleteRow = (rowkeyy) => {
        var temp_rows = [...products];
        for(var i=0; i < temp_rows.length; i++)
        {
            if(temp_rows[i].rowkey === rowkeyy)
            {
                temp_rows.splice(i, 1);
                break;
            }
        }
        setProducts(temp_rows);
    }

    const inputsforpsadd = [
        {
            id:'cpgproduct',
            displayname: 'Product',
            name: 'product',
            type: 'text',
            refvar: psref,
            error: pserror,
            changehandler: psinputchange,
            datalist: productstrings,
            blurhandler: psinputblur
        }
    ]

    const inputforcpgsubmit = [
        {
            id:'cpgmq',
            displayname: 'Minimum Quantity',
            name: 'mq',
            type: 'number',
            refvar: mqref,
            error: mqerror,
            min: 0,
            changehandler: mqinputchange
        }
    ]

    const tablefields = [
        {'name':'Name', 'key':'name'},
        {'name':'Package', 'key':'package'},
        {'name':'Company', 'key':'company'},
        {'name': 'Delete', 'key': 'rowkey', transformerr: deleteRow, text: 'X', cs: { width: "70px" }},
    ]

    const params = useParams();

    const editProductGroup = (e) => {
        e.preventDefault();
        const data = {
            'minimumquantity': mq,
            'products': products,
            'pgid': params.pgid,
        }
        usHttp2(appvariables.apiurl + 'product/editproductgroup/', 'POST', data)
        .then((response) => response.json())
        .then((json) => {
            masterdispatcher(notificationsliceactions.updatenotification({'message': json.message, 'status': json.status}));
            masterdispatcher(loadingsliceactions.updateloading({'state': ''}));

            if(json.status === 'Success')
            {
                setCompany('');
                setMq(0);
                setPname('');
                setMqerror('');
                setProducts([]);
                setPserror('');
                psref.current.value = '';
                mqref.current.value = '';
                navigate(-1);
            }
        })
    }

    const [detdata, setDetdata] = useState([]);

    useEffect(() => {
        if(pgdetails)
        {
            setDetdata([
                {'name': 'Name', 'value': pgdetails['name']},
            ]);
        }
    },[]);

    return (
        <React.Fragment>
            <h4>Edit Product Group</h4>
            <CustomForm resetdisabled={true} submitdisabled={pname.length ===0 ||  pserror !== ''} inputboxstyle={'equal'} inputs={inputsforpsadd} submitHandler={addpstolocal} />
            <Table data={products} tablefields={tablefields} />
            <Details  dropdownstyle={'smallvalue'} cs={{width: '500px'}} data={detdata} />
            <CustomForm resetdisabled={true} submitdisabled={products.length === 0 || mq < 0} inputboxstyle={"equal"} inputs={inputforcpgsubmit} submitHandler={editProductGroup} />
        </React.Fragment>
    )
}

export default EditProductGroup;